/*
  BUY NOW - wlasny przycisk "kup od razu"

  PO CO.
  `{{ form | payment_button }}` renderuje <shopify-accelerated-checkout>, a ten
  sam decyduje, co pokazac: jesli sklep ma Shop Pay, wyswietla fioletowe
  "Kup, uzywajac Shop Pay", i nie da sie tego wylaczyc z motywu - w markupie
  siedzi `recommended="shop_pay"` obok `fallback="buy_it_now"`, a wybor nalezy
  do komponentu Shopify. Zeby miec czarny przycisk "Buy It Now" jak u Sleeka,
  trzeba go napisac samemu.

  DLACZEGO WLASNY KOMPONENT, A NIE HANDLER HORIZONA.
  Przycisk siedzi wewnatrz <product-form-component>, ktore przechwytuje
  `submit` i robi AJAX-owe dodanie do koszyka. Zwykly `<button type="submit">`
  z `return_to=/checkout` nigdy nie dojdzie do przegladarki, bo formularz nie
  wychodzi. Skladnia `on:click="/metoda"` Horizona wola metode NA JEGO
  komponencie - dopisanie tam czegokolwiek znaczyloby edycje `product-form.js`.
  Wlasny custom element jest tanszy i nie wchodzi nikomu w droge.

  CO ROBI.
  Czyta wariant i ilosc Z FORMULARZA w chwili klikniecia (nie przy starcie) -
  wybor wariantu podmienia `input[name="id"]` w locie. Dodaje do koszyka
  przez /cart/add.js i przerzuca na /checkout.
*/

/*
  CALOSC W IIFE, BO SKRYPT WCHODZI Z DWOCH MIEJSC: z bloku
  `accelerated-checkout` (przycisk pod wyborem wariantu) i z sekcji
  `product-information` (przyklejony pasek). Sam `customElements.get`
  nie wystarczy: `class` jest deklaracja leksykalna jak `let`, wiec drugie
  wykonanie pliku w tym samym zasiegu globalnym rzuciloby
  "Identifier 'SleekBuyNow' has already been declared" — i to ZANIM
  straznik zdazylby cokolwiek sprawdzic.
*/
(function () {
class SleekBuyNow extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    event.preventDefault();
    // Formularz produktu jest przodkiem, ale przy karcie prezentowej albo
    // w szufladzie moze go nie byc - wtedy nie mamy czego wyslac.
    // Przycisk stoi w formularzu produktu... ale nie zawsze. Na przyklejonym
    // pasku zakupowym siedzi POZA nim: <sticky-add-to-cart> jest rodzenstwem
    // sekcji produktu, nie jej dzieckiem. Wtedy szukamy formularza na stronie.
    // Czytamy z niego wariant i ilosc DOPIERO PRZY KLIKNIECIU, wiec pasek
    // zawsze kupuje to, co klient wlasnie wybral.
    const form = this.closest('form')
      || document.querySelector('product-form-component form[id^="BuyButtons-ProductForm"]')
      || document.querySelector('product-form-component form');
    if (!form) return;

    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = Number(quantityInput?.value) || 1;

    this.setBusy(true);

    try {
      const response = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
      });

      if (!response.ok) throw new Error(`cart/add ${response.status}`);

      window.location.href = this.dataset.checkoutUrl || '/checkout';
    } catch (error) {
      // Nie zjadamy bledu po cichu: przycisk wraca do stanu klikalnego,
      // zeby klient mogl sprobowac jeszcze raz albo uzyc "Dodaj do koszyka".
      this.setBusy(false);
      console.error('[sleek-buy-now]', error);
    }
  };

  setBusy(busy) {
    this.button.toggleAttribute('disabled', busy);
    this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
}

if (!customElements.get('sleek-buy-now')) {
  customElements.define('sleek-buy-now', SleekBuyNow);
}
})();
